module.exports = __webpack_public_path__ + "static/media/easter-card.1772b884.jpg";